import React from "react";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../catalyst/dialog";
import { Button } from "../catalyst/button";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  showConfirmButton?: boolean;
  confirmText?: string;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  title,
  children,
  showConfirmButton = true,
  confirmText = "확인",
}) => {
  return (
    <Dialog open={isOpen} onClose={onClose} size="sm">
      <DialogTitle>{title}</DialogTitle>
      <DialogBody>{children}</DialogBody>
      {showConfirmButton && (
        <DialogActions>
          <Button onClick={onClose} color="blue">
            {confirmText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default Modal;
